var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('m-a',{attrs:{"href":{name:_vm.editRoutes[this.itemType],params:Object.assign({}, _vm.routerParams)}}},[_c('m-icon',{attrs:{"icon":"pencil"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }